export default __webpack_public_path__ + "static/media/Icon_mic_cancel.44697402.svg";